import { render, staticRenderFns } from "./transferNeed.vue?vue&type=template&id=23720440&"
import script from "./transferNeed.vue?vue&type=script&lang=js&"
export * from "./transferNeed.vue?vue&type=script&lang=js&"
import style0 from "./transferNeed.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports